import request from '@/utils/request';
//分页查询直营市场会员数据
export function queryMemberOrderInfo(param) {
  return request('/report/pointFlowAnalysisPage', {
    method: 'POST',
    data: param,
  });
}
// 获取门店树形列表
export function getStoreTreeList() {
  return request('/store/queryTreeList', {
    method: 'GET',
  });
}
// 获取门店树形列表
export function getStoreAndArea() {
  return request('/user/storeAndArea', {
    method: 'GET',
  });
}

// 导出
export function exportMemberOrderInfo(param) {
  return request('/report/pointFlowAnalysisExport', {
    method: 'POST',
    data: param,
  });
}
